export const acceptanceBlockerLabels = {
  assignment_state: 'This assignment cannot be accepted in its current state. Contact your staffing coordinator.',
  approval_rejected: 'Organization approval was rejected. Contact your staffing coordinator.',
  job_unavailable: 'This job has ended or was cancelled. Contact your staffing coordinator.',
  shift_unavailable: 'This shift has ended or was cancelled. Contact your staffing coordinator.',
  schedule_conflict: 'This shift overlaps another assignment. Review your schedule with your staffing coordinator.',
} as const
export type AssignmentReadiness = {
  schemaVersion: 1; scope: 'assignment_acceptance'; userId: string; workerProfileId: string
  assignmentId: string; selectedTenantId: string; executionTenantId: string; checkedAt: string
  canAccept: boolean; blockers: Array<keyof typeof acceptanceBlockerLabels>; notices: string[]
}
export function validateAssignmentReadiness(payload: unknown, ownerId: string, tenantId: string, assignmentId: string): AssignmentReadiness | null {
  if (!payload || typeof payload !== 'object') return null
  const body = payload as Record<string, unknown>
  if (body.success !== true || !body.readiness || typeof body.readiness !== 'object') return null
  const value = body.readiness as Record<string, unknown>
  if (!ownerId || !tenantId || !assignmentId || value.schemaVersion !== 1 || value.scope !== 'assignment_acceptance'
    || value.userId !== ownerId || value.selectedTenantId !== tenantId || value.assignmentId !== assignmentId
    || typeof value.workerProfileId !== 'string' || !value.workerProfileId.trim()
    || typeof value.executionTenantId !== 'string' || !value.executionTenantId.trim()
    || typeof value.checkedAt !== 'string' || !Number.isFinite(Date.parse(value.checkedAt))
    || typeof value.canAccept !== 'boolean' || !Array.isArray(value.blockers) || !Array.isArray(value.notices)
    || value.blockers.some(code => typeof code !== 'string' || !Object.prototype.hasOwnProperty.call(acceptanceBlockerLabels, code))
    || value.notices.some(code => code !== 'company_approval_pending')
    || new Set(value.blockers).size !== value.blockers.length || new Set(value.notices).size !== value.notices.length
    || value.canAccept !== (value.blockers.length === 0)) return null
  return value as AssignmentReadiness
}
